var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { cursor: "pointer" } },
    [
      _c("svg-icon", {
        staticStyle: { "font-size": "20px" },
        attrs: { "icon-class": "top_question" },
        on: { click: _vm.click }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }